export abstract class DataGenerator<T> {
  protected _manual: T[] = [];
  protected _predefined: T[] = this.createPredefined();
  protected _generated: T[] = this.createGenerated();

  protected constructor() {}

  // A handfull of predefined classes are used for deeper testing
  protected abstract createPredefined(): T[];
  get predefined(): T[] {
    return this._predefined;
  }

  // Generated instances should be minimally populated to test handling of a reduced object
  protected abstract createGenerated(): T[];
  get generated(): T[] {
    return this._generated;
  }

  get all(): T[] {
    return []
      .concat(this._manual)
      .concat(this._predefined)
      .concat(this._generated);
  }
}
